import { render, staticRenderFns } from "./lookDetail.vue?vue&type=template&id=37484192"
import script from "./lookDetail.vue?vue&type=script&lang=js"
export * from "./lookDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports